import _ from 'lodash'
import moment from 'moment'

import {
  GET_ALERTS,
  GET_ALERTS_SUCCESS,
  GET_ALERTS_FAIL,
  GET_CARETEAM_SUCCESS,
  SHOW_CARETEAM_MODAL,
  HIDE_CARETEAM_MODAL,
  OWN_ALERT,
  OWN_ALERT_FAIL,
  OWN_ALERT_SUCCESS
} from './actions.js'

const initialState = {
  initial: true,
  loading: true,
  error: false,
  showModal: false,
  alerts: [],
  careteam: null,
  owning: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case SHOW_CARETEAM_MODAL:
      return {
        ...state,
        showModal: true
      }
    case HIDE_CARETEAM_MODAL:
      return {
        ...state,
        showModal: false,
        careteam: null
      }
    case GET_ALERTS:
      return {
        ...state,
        loading: true
      }
    case GET_ALERTS_SUCCESS:
      return {
        ...state,
        initial: false,
        loading: false,
        error: false,
        alerts: action.results
          .map(a => _.mapKeys(a, (v, k) => _.camelCase(k)))
          .sort(
            (a, b) =>
              moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf()
          )
      }
    case GET_ALERTS_FAIL:
      return {
        ...state,
        loading: false,
        error: true
      }
    case GET_CARETEAM_SUCCESS:
      return {
        ...state,
        careteam: action.results
      }
    case OWN_ALERT:
      return {
        ...state,
        owning: true
      }
    case OWN_ALERT_SUCCESS:
      return {
        ...state,
        owning: false
      }
    case OWN_ALERT_FAIL:
      return {
        ...state,
        owning: false,
        error: action.err
      }
    default:
      return state
  }
}
